export const LAST_LOGOUT_TIMESTAMP_KEY = 'lastLogoutTimestamp'

// The sample rate for Sentry traces, set to 20% for performance monitoring
export const SENTRY_TRACE_SAMPLE_RATE = 0.2

// The sample rate for Mixpanel traces, set to 100% for detailed tracking
export const MIXPANEL_TRACE_SAMPLE_RATE = 1

export const SYSTEM_TYPE = {
  BRANCH_OFFICE: 'Branch-Office',
  HEAD_OFFICE: 'Head-Office',
  MULTI_OFFICE: 'Multi-Office',
  MULTI_SUB_OFFICE: 'Multi-Sub-Office',
  LITE_OFFICE: 'Lite-Office',
  SINGLE_OFFICE: 'Single-Office',
}

export const GAP_RELOAD_TO_LOGIN_PAGE = 10000 // in miliseconds
